import { isTrueValue } from "@utils/utilsValidators";

export function buildActivityPayload(
  inputForm: any,
  storyboard_id: number | string | null = null,
): unknown {
  const type = inputForm.type;
  let objToSend: any = {};

  if (type === "DA_XAPI") {
    objToSend = {
      type: inputForm.type,
      status: inputForm.status,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      expected_compl_time: +inputForm.expected_compl_time || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      expiration_date: inputForm.expiration_date || "",
      soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      xapi_package_id: +inputForm.xapi_package_id?.id,
      format: inputForm.format || null,
      fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: inputForm?.fruition_flag,
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
    };
  } else if (type === "DA_SCORM") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      expected_compl_time: +inputForm.expected_compl_time || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && +inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      expiration_date: inputForm.expiration_date || "",
      soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      scorm_package_id: +inputForm.scorm_package_id?.id,
      format: inputForm.format || null,
      fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: inputForm?.fruition_flag,
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
    };
  } else if (type === "DA_EXTERNAL_RES") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      expected_compl_time: +inputForm.expected_compl_time || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      expiration_date: inputForm.expiration_date || "",
      soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      external_file_url: inputForm?.external_file_url || "",
      format: inputForm.format || null,
      fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: inputForm?.fruition_flag,
      download_flag: inputForm["download_flag"] || null,
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
    };
  } else if (type === "DA_YOUTUBE") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      expected_compl_time: +inputForm.expected_compl_time || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      expiration_date: inputForm.expiration_date || "",
      soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      youtube_video: inputForm?.youtube_video || "",
      format: inputForm.format || null,
      fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: inputForm?.fruition_flag,
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
    };
  } else if (type === "DA_LINKEDIN") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      expected_compl_time: +inputForm.expected_compl_time || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      expiration_date: inputForm.expiration_date || "",
      soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      external_id: inputForm?.external_id || "",
      format: inputForm.format || null,
      fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: inputForm?.fruition_flag,
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
    };
  } else if (type === "DA_LTI") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration: +inputForm.duration || undefined,
      expected_compl_time: +inputForm.expected_compl_time || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      expiration_date: inputForm.expiration_date || "",
      soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      external_id: inputForm?.external_id || "",
      format: inputForm.format || null,
      fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: inputForm?.fruition_flag,
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
      lti_account_id: inputForm?.lti_account_id?.id || "",
    };
  } else if (type === "DA_PHYSICAL_CLASS") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      expected_compl_time: +inputForm.expected_compl_time || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      expiration_date: inputForm.expiration_date || "",
      soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      min_partecipant: +inputForm.min_partecipant,
      max_partecipant: +inputForm.max_partecipant,
      min_completition_perc: +inputForm.min_completition_perc,
      agenda: inputForm.agenda,
      phisical_edition: inputForm.phisical_edition || [],
      format: inputForm.format || null,
      fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      highlight_agenda: isTrueValue(inputForm?.highlight_agenda),
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
      self_enrollment: isTrueValue(inputForm.self_enrollment) || false,
    };
  } else if (type === "DA_VIRTUAL_CLASS") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      expected_compl_time: +inputForm.expected_compl_time || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      expiration_date: inputForm.expiration_date || "",
      soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      min_partecipant: +inputForm.min_partecipant,
      max_partecipant: +inputForm.max_partecipant,
      min_completition_perc: +inputForm.min_completition_perc,
      mandatory: isTrueValue(inputForm.mandatory) || false,
      agenda: inputForm.agenda,
      virtual_edition: inputForm.virtual_edition || [],
      format: inputForm.format || null,
      fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      highlight_agenda: isTrueValue(inputForm?.highlight_agenda),
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
      self_enrollment: isTrueValue(inputForm.self_enrollment) || false,
    };
  } else if (type === "DA_SURVEY") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone) || false,
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      score: +inputForm.score || undefined,
      useful_links: inputForm["useful_links"],
      knowledge_domain: inputForm["knowledge_domain"] || null,
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: isTrueValue(inputForm.fruition_flag),
      survey_id: Number(inputForm["survey_id"]) || null,
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
    };
  } else if (type === "DA_URL_RES") {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      note: inputForm.note || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: isTrueValue(inputForm.is_standalone),
      publish_date: inputForm.publish_date || "",
      obsolescent_date: inputForm.obsolescent_date || "",
      highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
      highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
      didactical_material:
        inputForm.didactical_material?.map((el: any) => +el.id) || "",
      certificate_ids: inputForm.certificate_ids || null,
      signature_certificate_ids: inputForm.signature_certificate_ids || null,
      badge_id: inputForm.badge_id || null,
      score: +inputForm.score || undefined,
      persona:
        inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
      external_file_url: inputForm["external_file_url"] || "",
      format: inputForm.format || null,
      useful_links: inputForm["useful_links"],
      complexity: inputForm["complexity"] || null,
      knowledge_domain: inputForm["knowledge_domain"] || null,
      learning_purpose: inputForm["learning_purpose"] || null,
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: isTrueValue(inputForm["fruition_flag"] || null),
      storyboard_id:
        storyboard_id != null && !!storyboard_id ? storyboard_id : null,
      completion_required: isTrueValue(inputForm["completion_required"]),
      client_id: inputForm["client_id"] || null,
      client_secret: inputForm["client_secret"] || null,
      flag_authentication:
        isTrueValue(inputForm["flag_authentication"]) || false,
      is_link_relative: isTrueValue(inputForm["is_link_relative"]) || false,
      is_editorial: isTrueValue(inputForm["is_editorial"]) || false,
    };
  } else if (
    ["DA_MATERIAL", "DA_GOALS", "DA_MEETING", "DA_FINAL_BALANCE"].includes(type)
  ) {
    objToSend = {
      type: inputForm.type,
      title: inputForm.title || "",
      description: inputForm.description || "",
      detail_description: inputForm.detail_description || "",
      duration:
        inputForm.duration === "0" ? 0 : +inputForm.duration || undefined,
      cover_id:
        (inputForm["cover_id"] && +inputForm["cover_id"]?.id) || undefined,
      video_id:
        (inputForm["video_id"] && inputForm["video_id"]?.id) || undefined,
      is_standalone: false, // BY DEFAULT
      useful_links: inputForm["useful_links"],
      digited_code: inputForm["digited_code"] || null,
      fruition_flag: inputForm["fruition_flag"] || null,
    };
  }

  objToSend = {
    ...objToSend,
    credits: inputForm.credits,
    lo_tag: inputForm.lo_tag ?? [],
    stakeholders: inputForm.stakeholders ?? [],
    time_slots: inputForm.time_slots ?? [],
  };

  const resetStandaloneItems = {
    publish_date: null,
    obsolescent_date: null,
    expiration_date: null,
    soft_expiring: null,
    highlight_for_you: null,
    highlight_explore: null,
    fixed_expiration: null,
    expected_compl_time: 1,
  };

  if (!isTrueValue(inputForm.is_standalone)) {
    objToSend = { ...objToSend, ...resetStandaloneItems };
  }

  const resetExpirationFlag = {
    expiration_date: 253402214400000,
    soft_expiring: true,
    fixed_expiration: true,
    expected_compl_time: 1,
  };

  if (!isTrueValue(inputForm.expiration_date_flag)) {
    objToSend = { ...objToSend, ...resetExpirationFlag };
  }

  return objToSend;
}
